"use client";
import { _eventBus } from "../../core/events/EventBus";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

type RouteChangeData = string | { stepBack?: boolean };

export function useRoutingHook() {
  const router = useRouter();

  useEffect(() => {
    _eventBus.on<RouteChangeData, void>({
      eventName: "ROUTE_CHANGE",
      handler: async ({ data }) => {
        if (!data) return;

        if (typeof data === "object" && data.stepBack) {
          router.back();
          return;
        }

        if (typeof data === "string") {
          router.push(data);
        }
      },
    });
  }, [router]);

  return true;
}

// This function will be used to trigger route changes
export function routeTo(route: string) {
    _eventBus.emit({
        eventName: "ROUTE_CHANGE",
        data: route
    });
}
